export enum AppActionKeys {
    NOTIFICATION = '@@app/NOTIFICATIONS',
    CALLOUTS = '@@Genie/CALLOUTS',
}
